import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    chart_data: {
      type: Array,
      default: null,
    },
  },
  methods: {
    drawChart(chartData) {
      // console.log('[ColorTotalChart.js] Drawing chart');	// Debug only

      const noData = chartData.reduce((sum, v) => {
        return v + sum;
      }, 0) == 0;
      // console.log('[ColorTotalChart.js] chartData/noData', chartData, noData);	// Debug only

      this.renderChart(
        {
          labels: ['Green Foods', 'Yellow Foods', 'Red Foods'],
          datasets: [
            {
              backgroundColor: noData ? ['#ccc'] : ['#669933', '#ffcc00', '#cc3333'],
              data: noData ? [1] : chartData,
            },
          ],
        },
        {
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
          plugins: {
            datalabels: {
              formatter: (value, ctx) => {
                let sum = 0;
                let dataArr = ctx.chart.data.datasets[0].data;
                dataArr.map(data => {
                  sum += data;
                });
                let percentage = Math.round(value * 100 / sum) + '%';
                return percentage;
              },
              color: '#fff',
              font: {
                weight: 'normal',
                size: 0,
              },
            },
          },
          cutoutPercentage: 60,
        }
      );
    },
  },
  mounted () {
    // console.log('[ColorTotalChart.js] mounted', this.chart_data);	// Debug only
    this.drawChart(this.chart_data);
  },
  watch: {
    chart_data: function (val) {
      this.drawChart(val);
    },
  },
}
